import React from 'react';
import {
    Edit,
    TextInput,
    TextField,
    SimpleForm,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

const editStyles = {
    root: { alignItems: 'flex-start' },
};

const DeviceEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextField source="id" />
            <TextInput source="vehicle" />
            <TextInput source="comment" />
            <TextField source="address" />
            <TextField disabled source="version" />
            <TextField source="service" />
            <TextField source="master" />
            <TextField source="status" />
            <TextField source="tunnel" />
            <TextField source="currentservice" />
            <TextField source="currentstatus" />
            <TextField source="currenttype" />
            <TextField source="gpstime" />
            <TextField source="time" />
            <TextField source="x" />
            <TextField source="y" />
            <TextField source="speed" />
            <TextField source="course" />
        </SimpleForm>
    </Edit>
);

export default withStyles(editStyles)(DeviceEdit);
